import { render, staticRenderFns } from "./Colleges.vue?vue&type=template&id=6b414e1e"
import script from "./Colleges.vue?vue&type=script&lang=js"
export * from "./Colleges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports